import { Translation } from "@/data/lang";
import { Lang } from "@/i18n-config";

import { PortfolioHoldingsData } from "../services/get-investor-portfolio-holdings";
import { PortfolioIndustryData } from "../services/get-investor-portfolio-industry";

export const industryColorsMap = ({
  t,
  lang,
}: {
  t: Translation;
  lang: Lang;
}) =>
  new Map<string, string>([
    [lang === "zh" ? "房地產" : "Real Estate", "#58C1D7CC"],
    [lang === "zh" ? "科技" : "Technology", "#2D80AFCC"],
    [lang === "zh" ? "工業" : "Industrials", "#003D70CC"],
    [lang === "zh" ? "循環性消費" : "Consumer Cyclical", "#4947BE80"],
    [lang === "zh" ? "原物料" : "Basic Materials", "#4947BECC"],
    [lang === "zh" ? "醫療保健" : "Health Care", "#159A5B80"],
    [lang === "zh" ? "能源" : "Energy", "#159A5BCC"],
    [lang === "zh" ? "金融服務" : "Financials", "#FDB62BCC"],
    [lang === "zh" ? "電信" : "Telecommunications", "#F67F13CC"],
    [lang === "zh" ? "非循環性消費" : "Consumer Noncyclical", "#EA433580"],
    [lang === "zh" ? "公用事業" : "Utilities", "#EA4335CC"],
    [t.my13F.investor.noStock, "#DEDEDE"],
  ]);

export const holdingsColorsMap = ({ t }: { t: Translation }) =>
  new Map<string | number, string>([
    [0, "#2D80AFCC"],
    [1, "#003D70CC"],
    [2, "#FDB62BCC"],
    [3, "#F67F13CC"],
    [4, "#EA4335CC"],
    [5, "#1f77b4"],
    [6, "#ff7f0e"],
    [7, "#2ca02c"],
    [8, "#d62728"],
    [9, "#9467bd"],
    [10, "#8c564b"],
    [11, "#e377c2"],
    [12, "#7f7f7f"],
    [13, "#bcbd22"],
    [14, "#17becf"],
    [15, "#aec7e8"],
    [16, "#ffbb78"],
    [17, "#98df8a"],
    [18, "#ff9896"],
    [19, "#c5b0d5"],
    [20, "#c49c94"],
    [t.my13F.investor.others, "#58C1D7CC"],
    [t.my13F.investor.noStock, "#DEDEDE"],
  ]);

export const getIndustryData = ({
  t,
  data,
}: {
  t: Translation;
  data: PortfolioIndustryData[];
}) =>
  data.map(({ proportion, quarter, sectorCategory }) => ({
    label: sectorCategory ?? t.my13F.investor.noStock,
    quarter: quarter ?? "",
    proportion: proportion ?? 0,
  }));

export const getHoldingsData = ({
  t,
  data,
}: {
  t: Translation;
  data: PortfolioHoldingsData[];
}) =>
  data.map(({ proportion, quarter, symbol }) => ({
    label: symbol
      ? symbol === "Others"
        ? t.my13F.investor.others
        : symbol
      : t.my13F.investor.noStock,
    quarter: quarter ?? "",
    proportion: proportion ?? 0,
  }));

export const getPortfolioDistributionOptions = ({ t }: { t: Translation }) => [
  { value: t.my13F.investor.industryDistribution },
  { value: t.my13F.investor.holdingsDistribution },
];
